export const es = {
  app: {
    name: 'Personaliza',
    brand: 'Besbello',
    loading: 'Cargando...',
    retry: 'Reintentar',
    dismiss: "Descartar",
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Cerrar',
    back: 'Atrás',
    next: 'Siguiente',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    search: 'Buscar',
    error: 'Algo ha ido mal',
    offline: 'Sin conexión. Los cambios se guardan cuando vuelva.',
  },
  nav: {
    catalog: 'Catálogo',
    myOrders: 'Mis pedidos',
    account: 'Mi cuenta',
    admin: 'Administración',
    login: 'Entrar con Besbello',
    loginLocal: 'Entrar',
    logout: 'Salir',
  },
  catalog: {
    title: 'Elige tu producto',
    subtitle: 'Camisetas, sudaderas, gorras y tazas para personalizar.',
    searchPlaceholder: 'Buscar por nombre o referencia',
    family: {
      all: 'Todo',
      tshirt: 'Camisetas',
      sweatshirt: 'Sudaderas',
      cap: 'Gorras',
      mug: 'Tazas',
      bag: 'Bolsas',
      other: 'Otros',
    },
    colors: '{count} colores',
    empty: 'No hay productos con esos filtros.',
    noPrice: 'Sin tarifa cargada',
    notCustomizable: 'Aún sin zona de marcaje',
    personalize: 'Personalizar',
  },
  product: {
    chooseColor: 'Color',
    chooseZone: 'Zona de marcaje',
    chooseTechnique: 'Técnica',
    chooseSize: 'Talla de referencia',
    zoneNote: 'La zona cambia con la talla: el diseño se adapta.',
    start: 'Empezar a diseñar',
    material: 'Composición',
    provenance: {
      inherited: 'Zona heredada del patrón',
      adjusted: 'Zona ajustada para este producto',
      exception: 'Zona con excepción abierta',
    },
    confidence: 'Confianza {value}%',
    notCalibrated: 'Este producto todavía no tiene zona de marcaje',
    notCalibratedHelp: 'Falta calibrarlo. Escríbenos y te preparamos el diseño a mano.',
  },
  editor: {
    shareReady: "Enlace de solo lectura. Vale 7 días.",
    share: "Compartir",
    title: 'Editor',
    addImage: 'Imagen',
    addText: 'Texto',
    addShape: 'Forma',
    maxSize: "Esta imagen llega bien hasta {w} × {h} mm a {dpi} ppp.",
    fitToMax: "Ajustar a {w} mm de ancho",
    removeBackground: "Quitar el fondo",
    vectorize: "Vectorizar",
    crop: "Recorte",
    crop_libre: "Original",
    crop_cuadrado: "Cuadrado",
    crop_apaisado: "Apaisado",
    crop_vertical: "Vertical",
    imageMode: "Tratamiento",
    mode_ninguno: "Como está",
    mode_grises: "Grises",
    mode_contrasteAlto: "Alto contraste",
    mode_unaTinta: "Una tinta",
    brightness: "Brillo",
    contrast: "Contraste",
    saturation: "Saturación",
    threshold: "Umbral",
    noImagesYet: "Todavía no has subido ninguna imagen.",
    reuseThis: "Usar esta imagen",
    adjustFit: "Ajustar dónde cae el estampado",
    adjustFitHelp: "Arrastra el recuadro sobre la foto. Afecta a todos los diseños de este producto.",
    mmPerPixel: "mm por píxel",
    rotateZone: "Girar la zona a {ancho} × {alto} mm",
    saveFit: "Guardar el encaje",
    fitSaved: "Encaje guardado y confirmado.",
    fix_resize: "Reducir a {valor} mm de ancho",
    fix_moveInside: "Meter dentro de la zona",
    fix_thickenStroke: "Engordar el trazo a {valor} mm",
    fix_growText: "Subir el texto a {valor} mm",
    fix_widenArc: "Abrir el arco a {valor} mm de radio",
    nudgeUp: "Subir un paso",
    nudgeDown: "Bajar un paso",
    nudgeLeft: "Mover a la izquierda",
    nudgeRight: "Mover a la derecha",
    nudgeHelp: "Ajuste fino. Pulsa el número para cambiar entre 1 y 10 mm.",
    canvasLabel: "Lienzo del diseño",
    zones: "Zonas de esta prenda",

    copyToZone: "Copiar a {zona}",
    inkColor: "Color de la tinta",
    inks: "{n} tintas",
    tooManyInks: "máximo {max}",
    screens: "{n} pantallas de serigrafía.",
    whiteBaseNeeded: "Sobre prenda oscura hace falta base blanca debajo: es una pantalla más y va incluida en el precio.",
    pantoneNote: "Los colores de pantalla son aproximados. La tinta se pide por su referencia.",
    view3d: "En 3D",
    downloadMockup: "Descargar la imagen",

    proofSheet: "Hoja de prueba (PDF)",
    downloadFailed: "No se pudo preparar la imagen de la prenda.",
    mockupDisclaimer: "Vista orientativa. No sustituye a una prueba impresa.",
    templates: "Plantillas",
    templatesHelp: "Un punto de partida que puedes cambiar entero.",

    templateInsert: "Insertar con mis datos",
    group: "Agrupar",
    ungroup: "Separar",
    copyDesign: "Copiar a otra prenda",
    copyDesignDone: "Diseño copiado. Ábrelo en la otra prenda.",
    bringDesign: "Tienes copiado el diseño de {producto} · {zona}.",
    bringDesignAction: "Traerlo aquí",
    bringDesignDone: "traer el diseño de otra prenda",
    myImages: "Mis imágenes",
    reuseImage: "Ya las has subido antes; reutilízalas sin volver a buscarlas.",
    ratioLocked: "Proporción bloqueada",
    ratioFree: "Proporción libre",
    alignTools: "Alinear",
    distributeH: "Repartir en horizontal",
    distributeV: "Repartir en vertical",
    alignTop: "Arriba",
    alignMiddle: "Centro",
    alignBottom: "Abajo",
    selectedCount: "{n} capas seleccionadas",
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    zoomFit: "Ajustar a la zona",
    zoomReset: "Tamaño real",
    weight: "Peso",
    weightNormal: "Normal",
    weightBold: "Negrita",
    weightBlack: "Negra",
    italic: "Cursiva",
    align: "Alineación",
    align_left: "Izquierda",
    align_center: "Centro",
    align_right: "Derecha",
    align_justify: "Justificado",
    textCase: "Mayúsculas",
    case_none: "Original",
    case_upper: "MAYÚS",
    case_lower: "minús",
    arc: "Arco",
    arcHint: "Curva el texto, como en un escudo.",
    arc_none: "Recto",
    arc_up: "Hacia arriba",
    arc_down: "Hacia abajo",
    outline: "Contorno",
    outlineHint: "Necesario si el texto no contrasta con la prenda.",
    fontGroup: { neutra: "Neutras", condensada: "Estrechas", impacto: "De impacto", serif: "Con remate", manuscrita: "Manuscritas", redondeada: "Redondeadas", decorativa: "Decorativas" },
    undo: 'Deshacer',
    redo: 'Rehacer',
    viewFlat: 'Plano',
    viewGarment: 'En la prenda',

    viewWorn: "Puesto",
    layers: 'Capas',
    layer: 'Capa',
    properties: 'Propiedades',
    position: 'Posición',
    size: 'Tamaño',
    rotation: 'Rotación',
    opacity: 'Opacidad',
    color: 'Color',
    font: 'Tipografía',
    textContent: 'Texto',
    delete: 'Eliminar capa',
    duplicate: 'Duplicar',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    bringForward: 'Subir',
    sendBackward: 'Bajar',
    center: 'Centrar',
    fitZone: 'Ajustar a la zona',
    zoneOutline: 'Zona de marcaje',
    saving: 'Guardando...',
    saved: 'Guardado',
    saveError: 'No se ha podido guardar',
    conflict: 'Alguien más ha editado este diseño',
    conflictHelp: 'Abriste el diseño en otra pestaña. Recarga para ver la versión actual; tu trabajo no se ha perdido.',
    mmUnit: 'mm',
    price: 'Precio',
    checkout: 'Continuar',
    emptyDesign: 'Añade una imagen o un texto para empezar.',

    contrastTitle: "Hay algo que no se va a ver",

    contrastBody: "Una capa es casi del color de la prenda: estampada apenas se distinguirá.",

    contrastFix: "Cambiar a un color visible",
    uploadHint: 'JPG, PNG, WEBP o SVG. Máximo {mb} MB.',
    photoWarning: 'Si subes una foto con personas, necesitamos su consentimiento.',
  },
  diagnostics: {
    title: 'Revisión técnica',
    none: 'Todo correcto para producir.',
    errors: '{count} problemas que impiden producir',
    warnings: '{count} avisos',
    estimated: 'medida estimada',
    codes: {
      LAYER_OUTSIDE_ZONE: 'La capa se sale {measured} mm de la zona de marcaje.',
      LAYER_OUTSIDE_CANVAS: 'La capa se sale del área visible.',
      DESIGN_AREA_EXCEEDED: 'El diseño ocupa {measured} mm² y el máximo son {expected} mm².',
      ZONE_TECHNIQUE_NOT_ALLOWED: 'Esta zona no admite la técnica elegida.',
      EFFECTIVE_DPI_TOO_LOW: 'La imagen queda a {measured} ppp y hacen falta {expected}. Usa una imagen mayor o redúcela.',
      IMAGE_UPSCALED: 'La imagen está ampliada: perderá nitidez.',
      TOO_MANY_INKS: 'Hay {measured} tintas y el máximo son {expected}.',
      GRADIENT_NOT_ALLOWED: 'Esta técnica no reproduce fotografías ni degradados.',
      TECHNICAL_WHITE_NOT_AVAILABLE: 'Esta técnica no imprime blanco de base.',
      COLOR_TYPE_NOT_SUPPORTED: 'Ese tipo de color no se puede producir con esta técnica.',
      STROKE_TOO_THIN: 'El trazo mide {measured} mm y el mínimo son {expected} mm.',
      ARC_OVERLAP: "El texto en arco da más de una vuelta y las letras se pisan. Sube el radio o acorta el texto.",
      TEXT_TOO_SMALL: 'El texto mide {measured} mm y el mínimo son {expected} mm.',
      TEXT_NOT_FROZEN: 'El texto se congelará antes de producir.',
      GEOMETRY_ESTIMATED: 'La medida de esta capa es aproximada hasta congelar el texto.',
      SUBSTRATE_NOT_SUPPORTED: 'El material de esta prenda no admite la técnica elegida.',
      EXTERNAL_DIGITIZING_REQUIRED: 'El bordado necesita digitalización previa; va incluida en el presupuesto.',
      EMPTY_DESIGN: 'El diseño está vacío.',
      LAYER_LIMIT_EXCEEDED: 'Hay {measured} capas y el máximo son {expected}.',
    },
  },
  pricing: {
    title: 'Precio',
    breakdown: 'Desglose',
    subtotal: 'Base',
    vat: 'IVA',
    total: 'Total',
    quantity: 'Unidades',
    validUntil: 'Válido hasta {date}',
    expired: 'Este presupuesto ha caducado. Lo recalculamos.',
    recalculate: 'Recalcular',
    concepts: {
      PRODUCT_BASE: 'Prenda {sku}',
      SETUP: 'Preparación del pedido',
      SETUP_PER_INK: 'Preparación por tinta ({inks} tintas)',
      UNIT_MARKING: 'Marcaje por unidad',
      PER_INK_UNIT: 'Recargo por tinta ({inks})',
      PER_PASS_UNIT: 'Recargo por pasada ({passes})',
      SURCHARGE: 'Recargo {surcharge}',
      MINIMUM_ORDER_ADJUSTMENT: 'Ajuste al pedido mínimo',
    },
    surcharges: {
      LARGE_AREA: 'por área grande',
      DARK_GARMENT_WHITE_BASE: 'por base blanca en prenda oscura',
    },
  },
  checkout: {
    title: 'Finalizar pedido',
    sizes: 'Tallas y cantidades',
    addSize: 'Añadir talla',
    wallet: 'Monedero Besbello',
    walletBalance: 'Saldo disponible: {amount}',
    walletUse: 'Pagar con saldo',
    walletNone: 'No tienes tarjeta de fidelización asociada.',
    terms: 'Acepto las condiciones de contratación',
    marketing: 'Quiero recibir novedades y ofertas (opcional)',
    confirm: 'Confirmar pedido',
    decision: {
      PAYMENT: 'Puedes pagar ahora',
      MANUAL_QUOTE: 'Este pedido lo revisa una persona',
      WITHIN_THRESHOLDS: 'El importe y la cantidad entran en el pago directo.',
      TOTAL_ABOVE_THRESHOLD: 'El importe supera el límite de pago directo.',
      QTY_ABOVE_THRESHOLD: 'La cantidad supera el límite de pago directo.',
      TECHNIQUE_REQUIRES_QUOTE: 'Esta técnica necesita revisión comercial.',
      DESIGN_HAS_BLOCKING_DIAGNOSTICS: 'El diseño tiene problemas técnicos por resolver.',
      QUOTE_EXPIRED: 'El presupuesto ha caducado.',
    },
  },
  orders: {
    repeat: "Pedir otra vez",
    title: 'Mis pedidos',
    empty: 'Todavía no tienes pedidos.',
    reference: 'Referencia',
    status: 'Estado',
    total: 'Total',
    date: 'Fecha',
    detail: 'Ver pedido',
    cancel: 'Cancelar pedido',
    statuses: {
      DRAFT: 'Borrador',
      AWAITING_PAYMENT: 'Esperando pago',
      PAID: 'Pagado',
      IN_PRODUCTION: 'En producción',
      READY: 'Listo para recoger',
      DELIVERED: 'Entregado',
      CANCELLED: 'Cancelado',
      REFUNDED: 'Reembolsado',
      QUOTE_REQUESTED: 'Presupuesto solicitado',
    },
  },
  admin: {
    title: 'Administración',
    catalog: 'Catálogo',
    calibration: 'Calibración',
    exceptions: 'Excepciones',
    sampling: 'Muestreo',
    pricing: 'Tarifas',
    workshop: 'Taller',
    kpi: {
      title: 'Indicadores',
      coverage: 'Cobertura del catálogo',
      skusPerHour: 'SKU por hora de persona',
      samplingError: 'Error detectado en muestreo',
      openExceptions: 'Excepciones abiertas',
      reviewed: 'Revisadas',
    },
    calibrator: {
      title: 'Calibrador de zonas',
      help: 'Arrastra los vértices para ajustar la zona sobre la foto. Las medidas están en milímetros reales.',
      confirm: 'Confirmar corrección',
      confirmHelp: 'Una corrección confirmada sobrevive a las reimportaciones del catálogo.',
      provenance: 'Procedencia',
      trace: 'Cómo se calculó',
    },
    import: {
      title: 'Importar catálogo',
      dryRun: 'Simular sin guardar',
      run: 'Importar',
      added: 'Altas',
      updated: 'Cambios',
      retired: 'Retirados',
      conflicts: 'Choques con correcciones manuales',
    },
  },
  rgpd: {
    title: 'Datos y privacidad',
    consents: 'Consentimientos',
    marketing: 'Comunicaciones comerciales',
    photoUpload: 'Fotos con personas',
    export: 'Descargar mis datos',
    erase: 'Solicitar supresión',
    requests: 'Mis solicitudes',
    photoNotice:
      'Si la imagen que subes tiene personas reconocibles, es un dato personal. Necesitamos su consentimiento y puedes retirarlo cuando quieras.',
  },





















  equipo: {





















    titulo: "Equipo",





















    ayuda: "Pega la lista del club: una línea por persona («Aitor 10 M», o con comas). Cada miembro se valida con su nombre puesto.",





















    sinRoles: "Marca antes qué texto es el nombre y cuál el dorsal, en las propiedades de la capa.",





















    cargar: "Cargar la lista",





















    nombre: "Nombre",





















    dorsal: "Dorsal",





















    talla: "Talla",





















    estado: "Estado",





















    noCabe: "no cabe",





















    guardar: "Guardar serie ({n})",





















    guardadoOk: "Serie guardada.",





















    conProblemas: "{n} con problemas",





















    rolCampo: "Papel en el equipo",





















    rolLibre: "Texto libre",





















  },





















  template: {
    farewell: "Despedida",

    crew: "Peña de fiestas",

    anniversary: "Aniversario",

    grandpa: "Abuela/o",

    backNumber: "Dorsal de espalda",

    pet: "Mascota",

    kidBirthday: "Cumple infantil",

    localShop: "Negocio local",

    field: {

      teamName: "Nombre del equipo",

      number: "Dorsal",

      crewName: "Nombre de la peña",

      year: "Año",

      years: "Años",

      name: "Nombre",

      who: "¿Abuela o abuelo?",

      playerName: "Nombre del jugador",

      petName: "Nombre de la mascota",

      businessName: "Nombre del negocio",

      since: "Desde (año)",

    },
    team: "Equipo",
    company: "Empresa",
    event: "Evento",
    birthday: "Cumpleaños",
  },
  templateCat: {
    grupo: "Grupo",
    empresa: "Empresa",
    evento: "Evento",
    deporte: "Deporte",
  },
  shape: {
    rectangulo: "Rectángulo",
    "rectangulo-redondeado": "Redondeado",
    circulo: "Círculo",
    linea: "Línea",
    triangulo: "Triángulo",
    estrella: "Estrella",
    poligono: "Polígono",
    corazon: "Corazón",
    flecha: "Flecha",
    escudo: "Escudo",
    banderola: "Banderola",
  },
  designs: {
    title: "Mis diseños",
    empty: "Todavía no has empezado ningún diseño.",
    browse: "Ver el catálogo",
    layers: "{n} elementos",
    expiresIn: "caduca en {n} días",
  },
  shared: {
    gone: "Este enlace ya no vale",
    noDesign: "Este diseño está vacío.",
    readOnly: "Vista orientativa y de solo lectura. No sustituye a una prueba impresa.",
    expires: "El enlace vale hasta el {fecha}.",
  },
};
